import React, { Component } from 'react';
import { redirectTo404 } from '../../actions/redirect-to-404';
import Page from '../../components/page';
import { FullHeightLayout, SimpleLayout } from '../../components/layout';
import NotFound from '../../components/not-found';
import AppLoaded from '../../components/app-loaded';
import forDevice from '../../hoc/for-device';

const Layout = forDevice(FullHeightLayout, SimpleLayout);

export class NotFoundPage extends Component {
  static fetchData = ({ pathname, store, search }) => {
    return store.dispatch(redirectTo404(search, pathname));
  };

  render() {
    return (
      <Page>
        <Layout>
          <NotFound/>
        </Layout>
        <AppLoaded/>
      </Page>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./app/containers/not-found-page/not-found-page.js